var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarBullet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84898 0.973288L8.15062 0.979189C7.98106 3.82578 7.52731 5.54843 6.50415 6.58588C5.48751 7.61673 3.82644 8.05135 0.997167 8.07425L0.992378 8.77416C3.72344 8.83365 5.35925 9.2207 6.3893 10.2403C7.42465 11.2651 7.92913 13.0077 8.15094 16.0257L8.8497 16.0146C8.9701 13.133 9.4916 11.4426 10.5581 10.4138C11.6292 9.38066 13.3271 8.93813 16.0213 8.77359L16.0156 8.07459C13.3386 7.95551 11.6922 7.5331 10.6436 6.52027C9.59469 5.50702 9.06753 3.82844 8.84898 0.973288Z",
    fill: "#FED75B",
    stroke: "black",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBullet);
export default __webpack_public_path__ + "static/media/star-bullet.39fa5dc22c86d234c74fce62fe797a19.svg";
export { ForwardRef as ReactComponent };